/* eslint-disable no-param-reassign */
import MatchMedia from '../../components/ui/MatchMedia/MatchMedia';
import PDPMobile from '../SoftLineProductContainer/Mobile/SoftLineMobile';
import PDPDesktop from './Desktop';
import { ModernProductContainerStyles } from './style';

const ModernProductContainer = () => (
  <div className="modern-product-container ">
    <MatchMedia
      content={{
        desktop: () => <PDPDesktop />,
        mobile: () => <PDPMobile />,
        tablet: () => <PDPMobile />,
      }}
    />
    <style jsx>{ModernProductContainerStyles}</style>
  </div>
);

export default ModernProductContainer;
